import { computeCoordinateExtents } from "utils/math/computeCoordinateExtents";
import type { UpdateRouteGeometryInPlan } from "./types";

export const updateRouteGeometryInPlan: UpdateRouteGeometryInPlan = ({
  plan,
  groupLabel,
  routeId,
  nodes,
  edges,
  meters,
}) => {
  const routeGroups = plan.routeGroups.map((group) => {
    if (group.label !== groupLabel) return group;

    const updatedRoutes = group.routes.map((route) =>
      route.id === routeId
        ? {
            ...route,
            nodes,
            edges,
            meters,
            coordinateExtents: computeCoordinateExtents(nodes),
          }
        : route,
    );

    const updatedGroupMeters = updatedRoutes.reduce(
      (sum, route) => sum + (Number(route.meters) || 0),
      0,
    );

    return {
      ...group,
      routes: updatedRoutes,
      meters: updatedGroupMeters,
    };
  });

  return { ...plan, routeGroups };
};
